import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRoute, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, switchMap } from 'rxjs/operators';
import { AkitaAuthService } from '../services/akita-auth.service';

import { AkitaAuthQuery } from '../store/auth/akita-auth.query';
import { AkitaAuthStore } from '../store/auth/akita-auth.store';

@Injectable()
export class AkitaAuthGuard implements CanActivateChild {
    constructor(private authQuery: AkitaAuthQuery, private router: Router, private authStore: AkitaAuthStore, private akitaAuthService: AkitaAuthService) { }

    canActivateChild(route: ActivatedRouteSnapshot, routeState: RouterStateSnapshot): Observable<boolean> {

        return this.authQuery.isLoggedIn$.pipe(
            take(1),
            switchMap((isLoggedIn) => {
                if (JSON.parse(localStorage.getItem('userAuth')) && JSON.parse(localStorage.getItem('userAuth')).token) {
                    let token = JSON.parse(localStorage.getItem('userAuth')).token;
                    if (!this.akitaAuthService.isTokenExpired(token)) {
                        if (!isLoggedIn) {
                            this.authStore.login(JSON.parse(localStorage.getItem('userAuth')));
                        }
                        return of(true);
                    } else {
                        if (isLoggedIn) {
                            this.authStore.logout();
                        }
                        this.router.navigate(['/login'], { queryParams: { returnUrl: routeState.url } });
                    }
                } else {
                    if (isLoggedIn) {
                        this.authStore.logout();
                    }
                    this.router.navigate(['/login'], { queryParams: { returnUrl: routeState.url } });
                }
            })
        );
        //return of(!!localStorage.getItem('userAuth'));
    }
}
